/**
 * Excel項目(読取項目)
 */
export const ExcelItemsConst =
{
  /** 売手コード[A列] */
  SellerCode: "0",
  /** 生産者コード[B列] */
  FarmerCode: "1",
  /** 生産者コード[C列] */
  FarmerName: "2",
  /** 生産者公開有無[D列] */
  IsFarmerHidden: "3",
  /** 茶期[E列] */
  TeaSeasonCode: "4",
  /** 茶種[F列] */
  TeaTypeCode: "5",
  /** 荷印[G列] */
  Brand: "6",
  /** 品種名[H列] */
  VarietyCode: "7",
  /** その他品種名[I列] */
  VarieryNameFree: "8",
  /** GAP区分[J列] */
  GapCode: "9",
  /** 栽培区分[K列] */
  CaltivationCategoryCode: "10",
  /** 容量(kg)①[L列] */
  Capacity1: "11",
  /** 本数①[M列] */
  Quantity1: "12",
  /** 容量(kg)②[N列] */
  Capacity2: "13",
  /** 本数②[O列] */
  Quantity2: "14",
  /** 最低落札値[P列] */
  BidMinPrice: "15",
  /** 備考[Q列] */
  Biko: "16",
} as const;
export type ExcelItemsType = typeof ExcelItemsConst[keyof typeof ExcelItemsConst]

/**
 * 通常入札用Excelのデータ列見出し（1行目・データ列のみ・総量等の表示列は含まない）。
 * アップロード時に選択中の出品区分と実際のファイルが一致しているかの判定に使う。
 */
export const ExcelItemsExpectedHeaders = [
  "売手コード", "生産者コード", "生産者名", "生産者公開有無",
  "茶期", "茶種", "荷印", "品種名", "その他品種名",
  "GAP区分", "栽培区分",
  "容量 (kg)①", "本数①", "容量 (kg)②", "本数②",
  "最低落札値", "備考",
] as const;

/**
 * 出品情報一括登録エクセルのファイル名称
 */
export const templateExcelFileName = "出品情報一括登録_ひな形.xlsx";
/**
 * 出品情報一括登録の結果エクセルのファイル名称
 */
export const resultExcelFileName = "出品情報一括登録_結果";